import { GridColumnWrapper } from './styles';

export default GridColumnWrapper;
